// Closed, curated vocabularies for the artist's sonic identity (R3.1, spec §3).
// Each axis (except `energy`, a 1..5 scalar) is a fixed enum so the prompt stays
// clean and the UI can render chip/pickers.
export const SONIC_GENRES = [
    "rock",
    "metal",
    "pop",
    "electronic",
    "hiphop",
    "jazz",
    "funk",
    "folk",
    "classical",
    "rnb",
    "reggae",
    "ambient",
];
export const SONIC_ERAS = ["60s", "70s", "80s", "90s", "2000s", "modern"];
export const SONIC_TIMBRES = [
    "warm",
    "bright",
    "dark",
    "gritty",
    "clean",
    "lofi",
    "lush",
    "minimal",
];
export const SONIC_VIBES = [
    "melancholic",
    "uplifting",
    "aggressive",
    "dreamy",
    "playful",
    "epic",
    "nostalgic",
    "groovy",
];
// The fixed axis order that render.ts and aggregate.ts iterate (spec §4.3).
export const SONIC_TRAIT_AXES = ["genres", "era", "timbre", "vibe", "energy"];
//# sourceMappingURL=vocabulary.js.map